import {AfterViewInit, Component, OnChanges, OnDestroy, SimpleChanges, ViewEncapsulation} from '@angular/core';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import TestReactComponent from './TestReactComponent';

@Component({
  selector: 'app-my-component',
  template: `
    <div [id]="rootId" style="transition: 0.6s"></div>`,
  encapsulation: ViewEncapsulation.None,
})


export class TestReactComponentWrapper implements OnChanges, OnDestroy, AfterViewInit {

  constructor() {
  }

  public rootId = "rootId"

  ngOnChanges(changes: SimpleChanges): void {
    this.render();
  }

  ngAfterViewInit() {
    this.render();
  }

  ngOnDestroy() {
  }

  private render() {
    ReactDOM.render(React.createElement(TestReactComponent), document.getElementById(this.rootId))
  }
}
